import { useEffect, useState } from 'react';

import format from 'date-fns/format';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { useDispatch, useSelector } from 'react-redux';

import { Pagination } from '../../components/Pagination';

import {
  downloadReport,
  fetchListReport,
  selectReportEntity,
} from './reportSlice';

export function Report() {
  const dispatch = useDispatch();
  const report = useSelector(selectReportEntity);
  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(fetchListReport({ page }));
  }, [dispatch, page]);

  return (
    <Row>
      <Col>
        <h4>Danh Sách Sản Phẩm</h4>
        <hr />
        <Table bordered responsive size="sm">
          <thead>
            <tr>
              <th>Batch #</th>
              <th>Mã SKU</th>
              <th>Tên SKU</th>
              <th>Ngày Tạo Serial</th>
              <th>CSV</th>
            </tr>
          </thead>
          <tbody>
            {report.ids.map((id) => (
              <tr key={id}>
                <td>{id}</td>
                <td>{report.entities[id].sku.skuId}</td>
                <td>{report.entities[id].sku.skuName}</td>
                <td>
                  {format(
                    new Date(report.entities[id].creationDate),
                    'dd/MM/yyyy hh:mm:ss'
                  )}
                </td>
                <td>
                  <Button
                    size="sm"
                    variant="success"
                    onClick={() => {
                      dispatch(
                        downloadReport({
                          id,
                          filename: `batch.${id}-${format(
                            new Date(report.entities[id].creationDate),
                            'dd.MM.yyyy-hh.mm.ss'
                          )}.csv`,
                        })
                      );
                    }}
                  >
                    Tải Về
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Pagination
          currentPage={page}
          totalItem={report.total}
          onPageChange={(page) => setPage(page)}
        />
      </Col>
    </Row>
  );
}
